import { useMemo } from "react";
import { SelectInputProps } from "../../../components/common/Inputs/SelectInput";
import { useRoles } from "./useRoles";

export const useRolesOptions = () => {
  const { roles, isLoading } = useRoles({
    filter: {},
    pagination: { page: 1, pageSize: 50 },
  });

  const rolesOptions: SelectInputProps["options"] = useMemo(() => {
    if (isLoading) return [];
    return roles.map((role) => ({
      label: role.name,
      value: role._id ? role._id : "",
    }));
  }, [roles, isLoading]);

  return {
    rolesOptions,
    isLoading,
  };
};
